import AxiosClient from "../../../services/axios.services";

class PlantillaCuestionarioServices {
  getPlantillaCuestionarios = (params) =>
    AxiosClient.get("/api/app/Clima_Plantilla_Cuestionario/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getPlantillaCuestionariosById = (id) =>
    AxiosClient.get(`/api/app/Clima_Plantilla_Cuestionario_listado/${id}/`, {
      headers: { "Content-Type": "application/json" },
      // params: params,
    });
  savePlantillaCuestionarios = (data) =>
    AxiosClient.post("/api/app/Clima_Plantilla_Cuestionario/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPlantillaCuestionarios = (id, data) =>
    AxiosClient.put(`/api/app/Clima_Plantilla_Cuestionario/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deletePlantillaCuestionarios = (id) =>
    AxiosClient.delete(`/api/app/Clima_Plantilla_Cuestionario/${id}`, {
      headers: { "Content-Type": "application/json" },
    });

  // Para Modal import cuestionario
  clonePlantillaCuestionario = (data) =>
    AxiosClient.post("/api/app/Clima_Plantilla_Cuestionario_Clonar/", data, {
      headers: { "Content-Type": "application/json" },
    });

  // Para Preguntas de plantilla
  getPreguntasPlantillaCuestionarios = (params) =>
    AxiosClient.get("/api/app/Clima_Cuestionario_Plantilla_Preguntas/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  // Para Crear Preguntas de plantilla
  savePlantillaCuestionariosPregunta = (data) =>
    AxiosClient.post("/api/app/clima_creacion_preguntas_y_opciones/", data, {
      headers: { "Content-Type": "application/json" },
    });

  // Para editar Preguntas de plantilla
  editPlantillaCuestionariosOpciones = (id, data) =>
    AxiosClient.put(
      `/api/app/Clima_Cuestionario_Plantilla_Preguntas/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  // Para eliminar preguntas
  deletePlantillaCuestionariosPregunta = (id) =>
    AxiosClient.delete(
      `/api/app/Clima_Cuestionario_Plantilla_Preguntas/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  // Para agregar opciones
  savePlantillaCuestionariosOpciones = (data) =>
    AxiosClient.post("/api/app/Clima_Cuestionario_Plantilla_Opciones/", data, {
      headers: { "Content-Type": "application/json" },
    });

  // Para eliminar opciones
  deletePlantillaCuestionariosOpciones = (id) =>
    AxiosClient.delete(`/api/app/Clima_Cuestionario_Plantilla_Opciones/${id}`, {
      headers: { "Content-Type": "application/json" },
    });

  // Para Modal import preguntas de cuestionario
  guardarImportarPreguntasPlantillaCuestionario = (data) =>
    AxiosClient.post("/api/app/clima_exportacion_preguntas/", data, {
      headers: { "Content-Type": "application/json" },
    });

  // Para cambiar tipo de pregunta
  saveCambiarPlantillaCuestionariosTipoPregunta = (data) =>
    AxiosClient.post("/api/app/clima_eliminado_y_creado_opciones/", data, {
      headers: { "Content-Type": "application/json" },
    });

  // Para Crear Preguntas de plantilla
  savePlantillaCuestionariosImport = (data) =>
    AxiosClient.post("/api/app/clima_clonacion_plantilla_cuestionario/", data, {
      headers: { "Content-Type": "application/json" },
    });

  // Para guardar cuestionario completo
  saveMasiveCuestion = (data) =>
    AxiosClient.post(
      "/api/app/clima_guardado_masivo_cuestionario_pregunta_opciones/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new PlantillaCuestionarioServices();
